import React from "react";
import { useNavigate } from "react-router-dom";
import { useLaunchParams } from "@telegram-apps/sdk-react";
import { useUserEvents } from "@/hooks/useLeaderboard";
import { Header } from "@/components/Header";
import { ReferralBottomNav } from "@/components/ReferralBottomNav";

export const EventsPage: React.FC = () => {
  const navigate = useNavigate();
  const launchParams = useLaunchParams();
  const userId = launchParams.initData?.user?.id?.toString();
  const { data: events } = useUserEvents(userId);

  return (
    <div className="min-h-screen flex flex-col">
      <Header
        backVisible={true}
        onBack={() => navigate("/referrals")}
        subtitle="Events"
      />
      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {events?.map((event) => (
          <div
            key={event.id}
            className="bg-tertiary border border-border rounded-xl p-4 flex items-center justify-between"
          >
            <div className="flex-1">
              <div className="text-text-primary font-medium">{event.name}</div>
              <div className="text-sm text-text-secondary">
                {event.description}
              </div>
            </div>
            <div className="text-right ml-4 flex flex-col items-end gap-2 justify-between">
              {event.eventType === "LIMITED" ? (
                <div
                  className={`text-xs ${event.completed ? "text-accent bg-accent/5 border border-accent text-accent-light" : "text-red-200 bg-red-500/5 border border-red-500 text-red-500"}
                    rounded-full
                    px-2 py-1`}
                >
                  {event.completed ? "Completed" : "Not completed"}
                </div>
              ) : (
                <div className="text-xs text-accent px-2 py-1 rounded-full bg-accent/5 border border-accent text-accent-light mt-1">
                  {event.completedCount || 0} times
                </div>
              )}
              <div className="text-accent-light font-semibold">
                {" "}
                {event.increaseMultiplier
                  ? `+${event.increaseMultiplier / 100}x`
                  : `+${event.points}`}
              </div>
            </div>
          </div>
        ))}
      </div>
      <ReferralBottomNav />
    </div>
  );
};
